export enum CopyOrderModalTestIds {
  MAINTAIN_PARTS_CHECKBOX = 'copy_order_maintain_parts_checkbox',
  MULTIPLIER_INPUT = 'copy_order_multiplier_input',
  CONFIRM_BUTTON = 'copy_order_confirm_button',
}
